var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3612:9279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.657 24.131c-.126.722.585 1.286 1.213.964l7.133-3.666 7.132 3.666c.628.322 1.34-.242 1.213-.962l-1.35-7.686 5.724-5.454c.536-.51.26-1.443-.458-1.544l-7.96-1.13-3.548-7.032a.833.833 0 0 0-1.507 0L8.7 8.32.741 9.451c-.717.1-.994 1.034-.46 1.544l5.725 5.453-1.349 7.686v-.003Zm7.97-4.496-5.989 3.078 1.128-6.43a.918.918 0 0 0-.265-.821L2.779 10.96l6.584-.936a.853.853 0 0 0 .639-.468L13 3.612l3.001 5.945a.853.853 0 0 0 .639.468l6.584.934-4.722 4.501a.917.917 0 0 0-.265.822l1.128 6.43-5.99-3.077a.818.818 0 0 0-.749 0h.002Z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3612:9279)",
    fill: ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.942 10.539a1.055 1.055 0 0 0-.366-.491 1.132 1.132 0 0 0-.589-.219l-6.271-.475-2.714-5.734a1.063 1.063 0 0 0-.405-.451 1.136 1.136 0 0 0-1.194 0c-.178.11-.318.266-.405.45L9.284 9.354l-6.27.475c-.212.016-.413.09-.581.212a1.054 1.054 0 0 0-.368.478c-.071.19-.084.395-.037.592.047.196.153.376.304.517l4.635 4.312-1.64 6.773c-.05.205-.033.42.046.616.08.196.22.365.4.485a1.137 1.137 0 0 0 1.238.009L13 20.012l5.989 3.81a1.14 1.14 0 0 0 1.257-.025c.182-.127.319-.303.392-.506.074-.203.08-.423.02-.63l-2.013-6.718 4.99-4.286a1.02 1.02 0 0 0 .306-1.118Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.657 24.131c-.126.722.585 1.286 1.213.964l7.133-3.666 7.132 3.666c.628.322 1.34-.242 1.213-.962l-1.35-7.686 5.724-5.454c.536-.51.26-1.443-.458-1.544l-7.96-1.13-3.548-7.032a.833.833 0 0 0-1.507 0L8.7 8.32.741 9.451c-.717.1-.994 1.034-.46 1.544l5.725 5.453-1.349 7.686v-.003Zm7.97-4.496-5.989 3.078 1.128-6.43a.918.918 0 0 0-.265-.821L2.779 10.96l6.584-.936a.853.853 0 0 0 .639-.468L13 3.612l3.001 5.945a.853.853 0 0 0 .639.468l6.584.934-4.722 4.501a.917.917 0 0 0-.265.822l1.128 6.43-5.99-3.077a.818.818 0 0 0-.749 0h.002Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3612:9279"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M0 0h26v26H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3612:9279"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M0 0h26v26H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSolid);
export default __webpack_public_path__ + "static/media/star_solid.364d9fe564e428242df3e070de9f6487.svg";
export { ForwardRef as ReactComponent };